'use strict';
import React, { PureComponent } from 'react'
import FiltrosAdicionales from './FiltrosAdicionales';
import SelectorFecha from '../Common/SelectorFecha';
import ListaModelosSeleccionados from '../Common/ListaModelosSeleccionados';

class SeccionFiltros extends PureComponent {
    constructor(props) {
        super(props);

        this.mostrarOcultarModalAsientosContables = this.mostrarOcultarModalAsientosContables.bind(this);
    }

    mostrarOcultarModalAsientosContables(nombreModal, mostrarModal){
        this.props.mostrarOcultarModalAsientosContables(nombreModal, mostrarModal);
    }

    render() {
        const {
            checkFechaContabilizacion,
            checkFechaValor,
            checkSoloNoBalanceados,
            checkSoloIngresadosModificadosManualmente,
            checkSoloConfirmadosManualmente,
            checkSoloDadosBaja,
            checkFechaRendicion,
            comboEstado,
            comboMarca,
            comboMoneda,
            comboSucursal,
            datosSucursales,
            datosEstados,
            datosMonedas,
            errorValidacion,
            estaDesplegado,
            inputFechaContabilizacionDesde,
            inputFechaContabilizacionHasta,
            inputFechaRendicionDesde,
            inputFechaRendicionHasta,
            inputFechaValorDesde,
            inputFechaValorHasta,
            inputIdAsiento,
            modelosContablesSeleccionados,
            mostrarVerMas,
            todosModelosSeleccionados,
            marcasActivas,
            handleConsultaRealizada
        } = this.props;

        //ACTIONS
        const {
            cargarInformacionBtnVer,
            cambiarCheckAsientosContables,
            cambiarValorInput,
            desplegarFiltros,
            guardarQuitarModeloSeleccionado,
            ocultarBotonVerMas,
            seleccionarOpcionCombo,
            validarInputFecha
        } = this.props;

        let mostrarConfirmacion = modelosContablesSeleccionados.length > 3;

        let estiloFlechaDesplegado = estaDesplegado ? "seccionRenglonesModelo__renglonModelo__trianguloUp AsientosContables__masFiltrosflechaDespliegue seccionRenglonesModelo__renglonModelo__trianguloUp--activo" : "seccionRenglonesModelo__renglonModelo__trianguloDown AsientosContables__masFiltrosflechaDespliegue"
        let classDisabled = {className: "form-control botonMenuProcesos--disabled"}
        let classInputFecha = "form-control form-control-tarjetas";
        let classInputFechaContabilidadDesde = {className: classInputFecha + (errorValidacion.inputFechaContabilizacionDesde ? "-error AsientosContables__seccionFiltrosFechasSuperiores--errorValidacion" : "")}
        let classInputFechaContabilidadHasta = {className: classInputFecha + (errorValidacion.inputFechaContabilizacionHasta ? "-error AsientosContables__seccionFiltrosFechasSuperiores--errorValidacion" : "")}
        let classInputFechaValorDesde = {className: classInputFecha + (errorValidacion.inputFechaValorDesde ? "-error AsientosContables__seccionFiltrosFechasSuperiores--errorValidacion" : "")}
        let classInputFechaValorHasta = {className: classInputFecha + (errorValidacion.inputFechaValorHasta ? "-error AsientosContables__seccionFiltrosFechasSuperiores--errorValidacion" : "")}
        let hayFiltroActivo = checkFechaContabilizacion || checkFechaValor || inputIdAsiento != ""
        let deshabilitarBotonVer = errorValidacion.inputFechaContabilizacionContenedor || errorValidacion.inputFechaValorContenedor || errorValidacion.inputFechaRendicionContenedor || !hayFiltroActivo;
   

        //Array que contendrá las opciones del combo de Marca
        let arrayOpcionesMarcas = [];
         //Lleno el combo de Marca. Se agrega la opción "Todas" como primer valor por default




        arrayOpcionesMarcas.push(
            <option key={-1} value={0}>Todas</option>
        );

        marcasActivas.map(codigo => {
            arrayOpcionesMarcas.push(
                <option key={codigo.Id} value={codigo.Id}>{codigo.Descripcion}</option>
            );
        });

        return (
            <div className="AsientosContables__contenedorFiltros">
                <div className="AsientosContables--overflowHidden">
                    <div className="AsientosContables--overflowHidden">
                        <div className="AsientosContables--floatLeft">
                            <div className="seccionDatosGenerales__tituloSecundario">Marca</div>

                            <div className="seccionDatosGenerales__contenedorSelectSucursal">
                                <select name="sucursalSelect" 
                                        className="seccionDatosGenerales__inputSelect seccionDatosGenerales__sucursalSelect AsientosContables__selectMarcaWidth" 
                                        onChange={(event) => {
                                            seleccionarOpcionCombo("comboMarca", event.target.value, mostrarConfirmacion);
                                        }}
                                        value={comboMarca}>                               
                                    {arrayOpcionesMarcas}
                                </select>
                            </div>
                        </div>

                        <div className="AsientosContables--floatRight">
                            <div className="seccionModelosBotonVer__contenedor">
                                <div className="seccionModelosBotonVer__seccionSeleccionModelos">
                                    <div className="seccionDatosGenerales__tituloSecundario">Modelo</div>

                                    <div className="AsientosContables__linkSeleccionar" onClick={() => this.mostrarOcultarModalAsientosContables("modalSeleccionModelos", true)}>
                                        Seleccionar...
                                    </div>
                                </div>

                                <div className="seccionModelosBotonVer__seccionBotonVer">
                                    <div className={deshabilitarBotonVer ? "AsientosContables__botonVerFiltros--deshabilitado" : ""}>
                                    <button 
                                        className={"seccionSuperior__botonNuevo AsientosContables__botonVerFiltros" + (deshabilitarBotonVer ? " seccionSuperior__botonNuevo--deshabilitado" : "")}
                                        onClick={() => {
                                            if (!deshabilitarBotonVer) {
                                                cargarInformacionBtnVer();
                                                handleConsultaRealizada();
                                            }
                                        }}
                                        disabled={deshabilitarBotonVer}
                                    >
                                        Ver
                                    </button>
                                    </div>
                                </div>
                            </div>



                            <div className="modalLogIntentosScroll AsientosContables__scrollModelosSeleccionadosEtiquetas">
                                <ListaModelosSeleccionados
                                    guardarQuitarModeloSeleccionado={guardarQuitarModeloSeleccionado}
                                    ocultarBotonVerMas={ocultarBotonVerMas}
                                    claseContenedor={"ContabilizadorRecontabilizador__contenedorModelosSeleccionadosPantallaPrincipal AsientosContables__contenedorModelosSeleccionadosPantallaPrincipal"}
                                    considerarVerMas={true}
                                    modelosContablesSeleccionados={modelosContablesSeleccionados}
                                    mostrarEtiquetaTodos={true}
                                    mostrarVerMas={mostrarVerMas}
                                    todosModelosSeleccionados={todosModelosSeleccionados}
                                />
                            </div>
                        </div>
                    </div>

                    {!hayFiltroActivo && 
                                <div>
                                    <label className="genericLabel errorMessage">Debe seleccionar al menos un filtro para realizar la busqueda de Asientos Contables.</label>
                                </div>
                            }
                    <div className="AsientosContables--overflowHidden AsientosContables__contenedorCheckBoxesFecha AsientosContables--floatLeft">
                        <div className="AsientosContables--floatLeft AsientosContables__contenedorFecha">
                            <div className="AsientosContables__contenedorCheckTitulo">
                                <div className="Tarjetas-contenedorCheckboxActivo default-checkbox Tarjetas-default-checkbox">
                                    <input id={"checkFechaContabilizacion"} type="checkbox" checked={checkFechaContabilizacion} onChange={() => cambiarCheckAsientosContables("checkFechaContabilizacion", !checkFechaContabilizacion)} />
                                    <label className={"label-primary Tarjetas-checkboxLabel" + (checkFechaContabilizacion ? " Tarjetas-checkboxLabel--checked" : "")} htmlFor={"checkFechaContabilizacion"}></label>
                                </div>
                                <label className={"label-primary seccionDatosGenerales__label AsientosContables__tituloCheckBoxes"}>Fecha contabilización</label>
                            </div>

                            
                            <div className={`AsientosContables--overflowHidden${checkFechaContabilizacion ? "" : " disableDiv"}`}>
                                <div className={"AsientosContables--floatLeft"}>
                                    <SelectorFecha
                                        nombreInput={"inputFechaContabilizacionDesde"}
                                        claseContainer={"AsientosContables__seccionFiltrosFechasSuperiores AsientosContables__seccionFiltrosFechas AsientosContables--floatLeft AsientosContables__fechaDesdeMargin" + (checkFechaContabilizacion ? "" : " AsientosContables__seccionFiltrosFechas--disabled")}
                                        errorFormatoFecha={null}
                                        classTitulo={"seccionDatosGenerales__tituloSecundario"}
                                        fecha={inputFechaContabilizacionDesde}
                                        funcionSeleccion={validarInputFecha}
                                        inputProps={checkFechaContabilizacion ? classInputFechaContabilidadDesde : classDisabled}
                                        maxToday={true}
                                        titulo={"Desde"}
                                    />
                                </div>
                                <div className={"AsientosContables--floatLeft"}>
                                    <SelectorFecha
                                        nombreInput={"inputFechaContabilizacionHasta"}  
                                        claseContainer={"AsientosContables__seccionFiltrosFechasSuperiores AsientosContables__seccionFiltrosFechas AsientosContables--floatLeft" + (checkFechaContabilizacion ? "" : " AsientosContables__seccionFiltrosFechas--disabled")}
                                        errorFormatoFecha={null}
                                        classTitulo={"seccionDatosGenerales__tituloSecundario"}
                                        fecha={inputFechaContabilizacionHasta}
                                        funcionSeleccion={validarInputFecha}
                                        inputProps={checkFechaContabilizacion ? classInputFechaContabilidadHasta : classDisabled}
                                        maxToday={true}
                                        titulo={"Hasta"}
                                    />
                                </div>
                            </div>

                            {errorValidacion.inputFechaContabilizacionContenedor && 
                                <div>
                                    <label className="error AsientosContables--errorWidth-contenedor">{errorValidacion.inputFechaContabilizacionContenedor}</label>
                                </div>
                            }
                        </div>

                        <div className="AsientosContables--floatLeft" onClick={null}>
                            <div className="AsientosContables__contenedorCheckTitulo">
                                <div className="Tarjetas-contenedorCheckboxActivo default-checkbox Tarjetas-default-checkbox">
                                    <input id={"checkFechaValor"} type="checkbox" checked={checkFechaValor} onChange={() => cambiarCheckAsientosContables("checkFechaValor", !checkFechaValor)} />
                                    <label className={"label-primary Tarjetas-checkboxLabel" + (checkFechaValor ? " Tarjetas-checkboxLabel--checked" : "")} htmlFor={"checkFechaValor"}></label>
                                </div>
                                <label className={"label-primary seccionDatosGenerales__label AsientosContables__tituloCheckBoxes"}>Fecha valor</label>
                            </div>


                            <div className={"AsientosContables--overflowHidden" + (checkFechaValor ? "" : " disableDiv")}>
                                <div className={"AsientosContables--floatLeft"}>
                                    <SelectorFecha 
                                        nombreInput={"inputFechaValorDesde"}  
                                        claseContainer={"AsientosContables__seccionFiltrosFechasSuperiores AsientosContables__seccionFiltrosFechas AsientosContables--floatLeft AsientosContables__fechaDesdeMargin" + (checkFechaValor ? "" : " AsientosContables__seccionFiltrosFechas--disabled")}
                                        errorFormatoFecha={null}
                                        classTitulo={"seccionDatosGenerales__tituloSecundario"}
                                        fecha={inputFechaValorDesde}
                                        funcionSeleccion={validarInputFecha}
                                        inputProps={checkFechaValor ? classInputFechaValorDesde : classDisabled}
                                        maxToday={true}
                                        titulo={"Desde"}
                                    />
                                </div>

                                <div className={"AsientosContables--floatLeft"}>
                                    <SelectorFecha 
                                        nombreInput={"inputFechaValorHasta"}
                                        claseContainer={"AsientosContables__seccionFiltrosFechasSuperiores AsientosContables__seccionFiltrosFechas AsientosContables--floatLeft" + (checkFechaValor ? "" : " AsientosContables__seccionFiltrosFechas--disabled")}
                                        errorFormatoFecha={null}
                                        classTitulo={"seccionDatosGenerales__tituloSecundario"}
                                        fecha={inputFechaValorHasta}
                                        funcionSeleccion={validarInputFecha}
                                        inputProps={checkFechaValor ? classInputFechaValorHasta : classDisabled}
                                        maxToday={true}
                                        titulo={"Hasta"}
                                    />
                                </div>
                            </div>

                            {errorValidacion.inputFechaValorContenedor && 
                                <div>
                                    <label className="error">{errorValidacion.inputFechaValorContenedor}</label>
                                </div>
                            } 
                        </div>
                    </div>

                    <div className="AsientosContables--floatRight AsientosContables--overflowHidden AsientosContables__contenedorBotonMasFiltros">
                        <div className={"AsientosContables--floatLeft AsientosContables__masFiltros" + (estaDesplegado ? " AsientosContables__masFiltros--activo" : "")}>Más filtros</div>

                        <div className="seccionRenglonesModelo__renglonModelo__contenedorRegistros">
                            <div className={estiloFlechaDesplegado} onClick={() => desplegarFiltros(!estaDesplegado)}></div>
                        </div>
                    </div>
                </div>

                <FiltrosAdicionales
                    cambiarCheckAsientosContables={cambiarCheckAsientosContables}
                    cambiarValorInput={cambiarValorInput}
                    seleccionarOpcionCombo={seleccionarOpcionCombo}
                    validarInputFecha={validarInputFecha}

                    checkSoloNoBalanceados={checkSoloNoBalanceados}
                    checkSoloIngresadosModificadosManualmente={checkSoloIngresadosModificadosManualmente}
                    checkSoloConfirmadosManualmente={checkSoloConfirmadosManualmente}
                    checkSoloDadosBaja={checkSoloDadosBaja}
                    checkFechaRendicion={checkFechaRendicion}
                    classInputFecha={classInputFecha}
                    comboEstado={comboEstado}
                    comboMoneda={comboMoneda}
                    comboSucursal={comboSucursal}
                    datosSucursales={datosSucursales}
                    datosEstados={datosEstados}
                    datosMonedas={datosMonedas}
                    errorValidacion={errorValidacion}
                    estaDesplegado={estaDesplegado}
                    inputFechaRendicionDesde={inputFechaRendicionDesde}
                    inputFechaRendicionHasta={inputFechaRendicionHasta}
                    inputIdAsiento={inputIdAsiento}
                />
            </div>
        );
    }
}

export default SeccionFiltros;